export const possibleLanguages = [
    "en-AU",
    "en-CA",
    "de",
    "en-EN",
    "es",
    "fr",
    "en-IE",
    "it",
    "jp",
    "kr",
    "nl",
    "en-NZ",
    "en-US",
    "dummy",
    "no"
];

export const languageToJsonMap = {
    "en-AU": "texts-au.json",
    "en-CA": "texts-ca.json",
    "en": "texts-en.json",
    "de": "texts-de.json",
    "en-EN": "texts-en.json",
    "es": "texts-es.json",
    "fr": "texts-fr.json",
    "en-IE": "texts-ie.json",
    "it": "texts-it.json",
    "jp": "texts-jp.json",
    "kr": "texts-kr.json",
    "nl": "texts-nl.json",
    "en-NZ": "texts-nz.json",
    "en-US": "texts-us.json",
    "dummy": "texts-dummy.json",
    "no": "texts-no.json"
}

